/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Value_TailInputs */

const en_pricing_page_value_tail = /** @type {(inputs: Pricing_Page_Value_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`instead of five.`)
};

const pl_pricing_page_value_tail = /** @type {(inputs: Pricing_Page_Value_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zamiast pięciu.`)
};

/**
* | output |
* | --- |
* | "instead of five." |
*
* @param {Pricing_Page_Value_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_value_tail = /** @type {((inputs?: Pricing_Page_Value_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Value_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_value_tail(inputs)
	return en_pricing_page_value_tail(inputs)
});